import classNames from 'classnames';
import React, { useCallback } from 'react';

import { usePostMessage } from 'src/contexts/message';
import { usePageTitle } from 'src/hooks/usePageTitle';
import { useResizeObserverRef } from 'src/hooks/useResizeObserver';

type Props = {
    className?: string;
};

export function Widget({ className, children }: React.PropsWithChildren<Props>) {
    usePageTitle();

    const postMessage = usePostMessage();
    const containerRef = useResizeObserverRef(
        useCallback(
            (entries) => {
                for (const entry of entries) {
                    if (!entry?.borderBoxSize?.[0]?.blockSize) {
                        continue;
                    }

                    postMessage({
                        message: 'myhealth-booking-ui-widget-resize',
                        value: entry.borderBoxSize[0].blockSize,
                    });
                }
            },
            [postMessage]
        )
    );

    return (
        <>
            <style>
                {`html, body {
                overflow: hidden;
            }`}
            </style>
            <div ref={containerRef} className={classNames('', className)}>
                {children}
            </div>
        </>
    );
}
